<template>
  <div class="sticky-panel">
    <div class="flex flex-wrap">
      <div class="w-full xl:w-1/2 p-3">
        <a @click="onClickRequestTender()">
          <div class="profile-panel">
            <div class="panel-title">
              {{ $t("sticky.requestTender") }}
            </div>
            <div class="panel-subtitle">
              {{ $t("sticky.oneMinAndFree") }}
            </div>
            <div class="panel-icon">
              <IconComponent icon="play" />
            </div>
          </div>
        </a>
      </div>

      <div class="w-full xl:w-1/2 p-3">
        <a
          v-if="person.isActive && person.publicPhoneNumber?.number"
          class="phone-panel"
          :href="$helpers.getPhoneNumberLink(person.publicPhoneNumber)"
          @click="onClickPhoneNumber"
        >
          <div class="profile-panel">
            <div class="panel-title">
              {{ $helpers.formatPhoneNumber(person.publicPhoneNumber) }}
            </div>
            <div class="panel-subtitle">
              {{ $t("sticky.callMeControl") }}
            </div>
            <div class="panel-icon">
              <IconComponent icon="phone-alt" />
            </div>
            <div
              class="phone-info flex flex-row gap-2 items-center"
              @click.stop.prevent="
                () =>
                  $joszaki.alert({
                    message: $t('sticky.phoneTooltip'),
                    type: 'info',
                  })
              "
            >
              <IconComponent icon="info-circle" />
              {{ $t("sticky.phoneHint") }}
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {
  useTrackFrontendEvent,
  FRONTEND_EVENT_TYPE,
  FRONTEND_EVENT_PLACEMENT,
} from "~/composables/tracking/useTrackFrontendEvent";

export default {
  props: {
    person: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { trackFrontendEvent } = useTrackFrontendEvent();
    return {
      trackFrontendEvent,
    };
  },
  methods: {
    onClickPhoneNumber() {
      this.trackFrontendEvent({
        eventType: FRONTEND_EVENT_TYPE.PHONE_CLICK,
        personId: this.person?.id,
        placement: FRONTEND_EVENT_PLACEMENT.STICKY_PANEL,
      });

      this.$trackers.trackEvent({
        title: "Clicked on Phone Number on Profile",
        data: {
          personId: this.person?.id,
          personSeoName: this.person?.seoName,
        },
      });
      this.$track.customEvent({
        event: "initiate_call",
        ecommerce: { items: [this.person.id] },
      });
    },
    onClickRequestTender() {
      this.$emit("requestTender");
    },
  },
};
</script>

<style lang="scss" scoped>
@use "styles/_all-members" as global;

.sticky-panel {
  position: sticky;
  top: 0.5rem;
  z-index: 2;
}

.phone-panel {
  .profile-panel {
    background-color: global.$primary;
  }
}

.profile-panel {
  color: #fff;
  background-color: #d9534f;
  border-color: #d43f3a;
  box-shadow: 0.08em 0.25em 0.4em rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  padding: 0.5rem 0.5rem;
  z-index: 2;

  display: grid;
  grid-template-rows: auto auto;
  grid-template-columns: auto 30px;
  grid-template-areas:
    "title icon"
    "subtitle icon";

  &:hover {
    box-shadow: 0.04em 0.1em 0.2em rgba(0, 0, 0, 0.35);
    color: #fff;
    background-color: #c9302c;
    border-color: #ac2925;
    text-decoration: none;
  }
}

.panel-title {
  grid-area: title;
  font-size: 1.5rem;
  font-weight: bold;
  font-family: "Noto Sans", "Arial", sans-serif;

  &:not(.\!text-primary-light) {
    text-shadow: 1px 2px 0 rgba(0, 0, 0, 0.35);
  }

  @include global.mobile {
    font-size: 1rem;
  }
}

.panel-subtitle {
  grid-area: subtitle;
}

.panel-icon {
  grid-area: icon;
  height: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: inherit;
  width: 30px;
}

.phone-panel {
  position: relative;
  z-index: 2;

  &:hover {
    .profile-panel {
      background-color: #286090;
      border-color: #204d74;
    }
  }
}

.phone-info {
  position: absolute;
  z-index: 2;
  bottom: -30px;
  color: black;
  right: 5px;
}
</style>
